<template>
  <div class="admin-login">
    <el-card class="login-card">
      <h2>管理员登录</h2>
      <el-form :model="loginForm" :rules="rules" ref="loginFormRef" @submit.prevent="handleLogin">
        <el-form-item label="用户名" prop="username">
          <el-input 
            v-model="loginForm.username" 
            placeholder="请输入用户名" 
            @keyup.enter="handleLogin"
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input 
            v-model="loginForm.password" 
            type="password" 
            placeholder="请输入密码" 
            show-password 
            @keyup.enter="handleLogin"
          />
        </el-form-item>
        <el-alert
          v-if="loginError"
          :title="loginError"
          type="error"
          :closable="false"
          style="margin-bottom: 20px;"
        />
        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading" style="width: 100%;">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '../../api'

export default {
  name: 'AdminLogin',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false,
      loginError: ''
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return

        this.loading = true
        this.loginError = ''

        try {
          const response = await api.post('/admin/auth/login/', this.loginForm)
          if (response.data.token) {
            localStorage.setItem('admin_token', response.data.token)
            this.$router.push('/admin')
          }
        } catch (error) {
          if (error.response && error.response.data) {
            this.loginError = error.response.data.error || '登录失败'
            if (error.response.data.remaining !== undefined) {
              this.loginError += `，还有${error.response.data.remaining}次机会`
            }
          } else {
            this.loginError = '登录失败，请稍后重试'
          }
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.admin-login {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

.login-card {
  width: 400px;
}

.login-card h2 {
  text-align: center;
  margin-bottom: 30px;
}
</style>

